export type ScenarioKey = 'cons' | 'pos';

export type RateKey =
	| 'storage'
	| 'capital'
	| 'deferred'
	| 'badDebt'
	| 'expired'
	| 'markdown'
	| 'weight'
	| 'returns'
	| 'site'
	| 'marketer'
	| 'ads'
	| 'articles'
	| 'ai'
	| 'exhibitions'
	| 'b2b';

export const SETTINGS = {
	workingDays: 21,
	hoursPerMonth: 168,
	platinumAdBudget: 40000,
	time: { consShare: 0.5, posShare: 0.25 },
	tariffs: { gold: 22500, platinum: 125000 },
	rates: {
		storage: { cons: 0.15, pos: 0.2 },
		capital: { cons: 0.15, pos: 0.2 },
		deferred: { cons: 0.1, pos: 0.15 },
		badDebt: { cons: 0.1, pos: 0.15 },
		expired: { cons: 0.2, pos: 0.25 },
		markdown: { cons: 0.0, pos: 0.1 },
		weight: { cons: 0.3, pos: 0.3 },
		returns: { cons: 0.1, pos: 0.15 },
		site: { cons: 0.5, pos: 1.0 },
		marketer: { cons: 0.5, pos: 1.0 },
		ads: { cons: 0.5, pos: 1.0 },
		articles: { cons: 0.2, pos: 0.5 },
		ai: { cons: 0.5, pos: 0.8 },
		exhibitions: { cons: 0.0, pos: 0.1 },
		b2b: { cons: 0.5, pos: 1.0 },
	},
} as const satisfies {
	workingDays: number;
	hoursPerMonth: number;
	platinumAdBudget: number;
	time: { consShare: number; posShare: number };
	tariffs: { gold: number; platinum: number };
	rates: Record<RateKey, Record<ScenarioKey, number>>;
};
